import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50008 3.66699C4.03984 3.66699 3.66675 4.04009 3.66675 4.50033V11.5003C3.66675 11.9606 4.03984 12.3337 4.50008 12.3337H11.5001C11.9603 12.3337 12.3334 11.9606 12.3334 11.5003V4.50033C12.3334 4.04008 11.9603 3.66699 11.5001 3.66699H4.50008ZM2.66675 4.50033C2.66675 3.4878 3.48756 2.66699 4.50008 2.66699H11.5001C12.5126 2.66699 13.3334 3.48781 13.3334 4.50033V11.5003C13.3334 12.5129 12.5126 13.3337 11.5001 13.3337H4.50008C3.48756 13.3337 2.66675 12.5129 2.66675 11.5003V4.50033Z"
      fill="currentColor"
    />
    <path
      opacity="0.8"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8536 4.81344C11.0489 5.0087 11.0489 5.32528 10.8536 5.52055L5.5203 10.8539C5.32504 11.0491 5.00846 11.0491 4.81319 10.8539C4.61793 10.6586 4.61793 10.342 4.81319 10.1468L10.1465 4.81344C10.3418 4.61818 10.6584 4.61818 10.8536 4.81344Z"
      fill="currentColor"
    />
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0202 7.64645C11.2155 7.84171 11.2155 8.15829 11.0202 8.35355L8.35355 11.0202C8.15829 11.2155 7.84171 11.2155 7.64645 11.0202C7.45118 10.825 7.45118 10.5084 7.64645 10.3131L10.3131 7.64645C10.5084 7.45118 10.825 7.45118 11.0202 7.64645Z"
      fill="currentColor"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6869 9.64645C11.8821 9.84171 11.8821 10.1583 11.6869 10.3536L10.3536 11.6869C10.1583 11.8821 9.84171 11.8821 9.64645 11.6869C9.45118 11.4916 9.45118 11.175 9.64645 10.9798L10.9798 9.64645C11.175 9.45118 11.4916 9.45118 11.6869 9.64645Z"
      fill="currentColor"
    />
  </SvgIcon>
));
